export const getGridOptionUtils = ({ edm, state }) => {
  if (!edm || !state) {
    return {};
  }
  const getEntitySetInSubAccount = () => {
    const subAccountId = state.get('subAccount_id');

    if (subAccountId) {
      return edm.currentAccount.SubAccounts.$withKey(subAccountId);
    }
    return edm.currentAccount;
  };

  const getEntitySetByScope = (scope) => {
    if (scope === 'account') {
      return edm.currentAccount;
    } else if (scope === 'subAccount') {
      return getEntitySetInSubAccount();
    } else if (scope === 'hotelGroup') {
      const hotelDrillDown = state.get('hotelGroup_drillDown');

      if (hotelDrillDown && hotelDrillDown.hotelGroupId) {
        return edm.currentAccount
          .SubAccounts.$withKey(hotelDrillDown.subAccountId)
          .HotelGroups.$withKey(hotelDrillDown.hotelGroupId);
      }
      return getEntitySetInSubAccount();
    }
    return null;
  };

  // name indicate the entitySet name
  const getEntitySetByName = (name, scope = 'subAccount') => {
    if (name === 'subAccount') {
      return edm.currentAccount.SubAccounts;
    } else if (name === 'hotelGroup') {
      return getEntitySetByScope(scope).HotelGroups;
    } else if (name === 'hotel') {
      return getEntitySetByScope(scope).Hotels;
    }
    return edm.currentAccount;
  };

  const getUrlWithSubAccountState = () => {
    const subAccountId = state.get('subAccount_id');

    if (subAccountId && subAccountId !== '') {
      return `/Customers(:advertisercustomer_id)/Accounts(:account_id)/SubAccounts('${subAccountId}')/`;
    }
    return '/Customers(:advertisercustomer_id)/Accounts(:account_id)/';
  };

  const getUrlByName = (name) => {
    if (name === 'associations') {
      const url = getUrlWithSubAccountState();

      return `${url}Associations?`;
    }
    return '';
  };

  return {
    gridOptionUtils: {
      getUrlByName,
      getEntitySetByName,
    },
  };
};
